module.exports = __webpack_public_path__ + "img/20200713-4.1db7bf54.png";